angular.module('language')
    .component('dropdownLanguageFlagComponent', {
        bindings: {
            language: '<',
            onChange: '&'
        },
        template: `
            <div class="flag-choser" uib-dropdown uib-keyboard-nav auto-dropdown>
                <button type="button" class="btn btn-default btn-sm" uib-dropdown-toggle>
                    <span ng-if="!$ctrl.language">-</span>
                    <img ng-src="/static/flags/{{$ctrl.flagFile($ctrl.language)}}" ng-if="$ctrl.language" alt="flag"/>
                </button>
                <ul uib-dropdown-menu>
                    <li ng-class="{ 'active': $ctrl.language.id === lang.id }" ng-repeat="lang in $ctrl.langs track by lang.id">
                        <a href ng-click="$ctrl.selectLanguage(lang)">
                            <img ng-src="/static/flags/{{$ctrl.flagFile(lang)}}" alt="flag"/>
                        </a>
                    </li>
                </ul>
            </div>
        `,
        controller: function(Language) {
            this.$onInit = () => {
                Language.getActive().then(items => {
                    this.langs = items
                    if(this.language == null)
                        this.selectLanguage(items.find(item => item.defaultValue === true))
                });
            }

            this.selectLanguage = selected => {
                this.language = selected;
                this.onChange({ language: selected });
            }
            this.flagFile = language => {
                if(language?.iso != null)
                    return language.iso + ".png";
                else
                    return "";
            };
        }
    })
    // .directive('dropdownLanguageFlag', function(Language) {
    //     return {
    //         restrict: 'AE',
    //         scope: {
    //             language: '='
    //         },
    //         replace: true,
    //         template: `
    //             <div class="flag-choser" uib-dropdown uib-keyboard-nav auto-dropdown>
    //                 <button type="button" class="btn btn-default btn-sm" uib-dropdown-toggle>
    //                     <img ng-src="/static/flags/{{flagFile(language)}}" ng-if="language" alt="flag"/>
    //                 </button>
    //                 <ul uib-dropdown-menu>
    //                     <li ng-class="{ 'active': language.id === lang.id }" ng-repeat="lang in langs track by lang.id">
    //                         <a href ng-click="selectLanguage(lang)">
    //                             <img ng-src="/static/flags/{{flagFile(lang)}}" alt="flag"/>
    //                         </a>
    //                     </li>
    //                 </ul>
    //             </div>
    //         `,
    //         link: function(scope, $element, $attrs) {
    //             Language.getActive().then(items => scope.langs = items);
    //
    //             scope.selectLanguage = selected => scope.language = selected;
    //             scope.flagFile = language => {
    //                 if(language !== null && angular.isDefined(language.iso))
    //                     return language.iso + ".png";
    //                 else
    //                     return "";
    //             };
    //         }
    //     };
    // });
